
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","d":"M12.051 31.276v7.474c0 1.203.93 2.178 2.075 2.178h20.748c1.146 0 2.075-.975 2.075-2.178V15.062a2.5 2.5 0 0 0-.73-1.76l-6.5-6.5a2.5 2.5 0 0 0-1.76-.73H14.125c-1.146 0-2.075.975-2.075 2.179v3.428m-.557 5.597h9.376m-5.09 7.469h8.711m-4.689 7.47h6.273m-21.42-14.94h4.867m1.003 7.47h3.234m13.542 7.47h2.068"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M31.02 8.354c.66 0 1.294.262 1.76.729l6.502 6.5c.467.467.728 1.101.728 1.761v23.687c0 1.203-.928 2.178-2.074 2.178H17.188c-1.146 0-2.074-.975-2.074-2.178V35.5h15.894v-5H15.114v-2.53h11.894v-5H15.114v-2.335h7.894v-5h-7.894v-5.104c0-1.203.928-2.178 2.074-2.178z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M12.051 31.276v7.474c0 1.203.93 2.178 2.075 2.178h20.748c1.146 0 2.075-.975 2.075-2.178V15.062a2.5 2.5 0 0 0-.73-1.76l-6.5-6.5a2.5 2.5 0 0 0-1.76-.73H14.125c-1.146 0-2.075.975-2.075 2.179v3.428m-.557 5.597h9.376m-5.09 7.469h8.711m-4.689 7.47h6.273m-21.42-14.94h4.867m1.003 7.47h3.234m13.542 7.47h2.068"}})])
          )
        }
      }
    